<div class="flex flex-col min-h-screen">
  <header>
    <reza-header />
    <reza-navbar />
  </header>
  @if (!hideBreadcrumb) {
    @if (breadcrumbs$ | async; as breadcrumbs) {
      <ui-wrapper class="pt-8">
        <page-settings-breadcrumbs [breadcrumbs]="breadcrumbs" />
      </ui-wrapper>
    }
  }
  <main class="flex-1">
    <ui-wrapper>
      <ui-router-outlet />
    </ui-wrapper>
  </main>
  <footer>
    <reza-footer [publicFooter]="true" />
  </footer>
</div>
